import { PagePanelHeader } from '@blackhyve/common';
import makeStyles from '@mui/styles/makeStyles';
import Grid from '@mui/material/Grid';
import { useEffect, useState } from 'react';
import { DragDropContext } from 'react-beautiful-dnd';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { reorderAreas } from '../store/areasSlice';
import { addEmptyLocation, fetchLocations, reorderLocations } from '../store/locationsSlice';
import { reorderZones } from '../store/zonesSlice';
import '../../../styles/area.css';
import DisplayWithEditAccess from 'components/common/v3/DisplayWithEditAccess';
import SkeletonListComponent from 'components/common/v3/SkeletonListComponent';
import LocationListComponent from '../components/LocationListComponent';

export const Locations = (props) => {
  const dispatch = useDispatch();
  const { projectId } = useParams();

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const handleAddLocation = () => {
    dispatch(addEmptyLocation({ projectId, id: Date.now() * -1 }));
  };

  const handleUpdatePriority = (data) => {
    const [type] = data.type.split('-');
    const parentId = data.destination.droppableId.split('-')[1];
    if (type === 'LOCATION') {
      dispatch(
        reorderLocations({
          sourceIndex: data.source.index,
          destinationIndex: data.destination.index,
          parentId: parentId,
        })
      );
    } else if (type === 'ZONE') {
      dispatch(
        reorderZones({
          sourceIndex: data.source.index,
          destinationIndex: data.destination.index,
          parentId: parentId,
        })
      );
    } else {
      dispatch(
        reorderAreas({
          sourceIndex: data.source.index,
          destinationIndex: data.destination.index,
          parentId: parentId,
        })
      );
    }
  };

  const headingButtons = [
    {
      title: '+ Location',
      handleClick: handleAddLocation,
    },
  ];

  useEffect(() => {
    dispatch(fetchLocations({ id: projectId }))
      .unwrap()
      .then(() => setLoading(false))
      .catch(() => setError(true));
  }, [dispatch, projectId]);

  return (
    <DragDropContext onDragEnd={handleUpdatePriority}>
      <Grid container item className={'background-div'} xs={12}>
        <Grid
          container
          alignItems={'center'}
          direction="column"
          wrap={'nowrap'}
          // style={{ backgroundColor: 'white' }}
        >
          <DisplayWithEditAccess>
            <Grid container item justifyContent={'center'}>
              <Grid container item xs={12}>
                <PagePanelHeader buttonItems={headingButtons}></PagePanelHeader>
              </Grid>
            </Grid>
          </DisplayWithEditAccess>
          <Grid container item padding={3} xs={12}>
            {loading ? (
              <SkeletonListComponent noOfRows={15} />
            ) : (
              <LocationListComponent projectId={projectId} />
            )}
          </Grid>
        </Grid>
      </Grid>
    </DragDropContext>
  );
};
